import { Box, HStack, Icon, Text, VStack, Image, Flex, WrapItem, Wrap, Heading, Highlight } from "@chakra-ui/react";
import { TbRefresh } from "react-icons/tb";
import { FaPaintBrush } from "react-icons/fa";
import { BsCameraFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { BsToggles } from "react-icons/bs";
import { SiGoogleanalytics } from "react-icons/si";
import { useEffect, useRef, useState } from "react";
import { logEvent } from "../../utils/google-analytics-lib/analytics";

export default function Features() {
  const [isVisible, setIsVisible] = useState(false);
  const [imageBackgroundColor, setImageBackgroundColor] = useState("#d4ffcd");
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const isVisible = rect.top + rect.height * 0.3 < window.innerHeight && rect.bottom >= rect.height * 0.5;
        setIsVisible(isVisible);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const backgroundColorMappingWithTabIndex = ["#d4ffcd", "#f5e4ec", "#ede5ff", "#d4ebff", "#ffebd3", "#cffefa"];
  const showFeature = (index: number) => {
    setTabIndex(index);
    setImageBackgroundColor(backgroundColorMappingWithTabIndex[index]);

    const featureDescriptions = ["Automated Requests", "Customize Widget", "Photo Reviews", "Customize Review Email", "Moderate", "Analytics"];
    const featureDescription = featureDescriptions[index] || "Default Description";
    logEvent("Features", "Click", `Feature - ${featureDescription}`);
  };
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Box py={20} bg={"#f3f7ff"} ref={ref}>
      <Heading lineHeight="tall" fontFamily={"heading"} textAlign={"center"} fontSize={{ base: "4xl", md: "4xl", lg: "5xl" }}>
        <Highlight query="Key Features" styles={{ px: "1", py: "1", rounded: "full", textDecoration: "underline", textDecorationStyle: "wavy", textDecorationColor: "brand.500", textDecorationThickness: "8px", textUnderlineOffset: "12px" }}>
          Checkout Some of Our Key Features
        </Highlight>
      </Heading>
      <Flex maxW={"8xl"} mx={"auto"} mt={"20"} id="reviews-features">
        <Wrap spacing={{ base: "20px", lg: "50px" }}>
          <WrapItem w={{ base: "100%", md: "250px", lg: "310px" }} className={isVisible ? "animate-fade-down" : "opacity-zero"}>
            <VStack spacing={5} bg={"white"} borderRadius={"30px"} p={"4"} w={"100%"}>
              <HStack
                py={{ base: 2, lg: 5 }}
                bg={"#d4ffcd"}
                w={{ base: "90%", lg: "100%" }}
                borderRadius={"2xl"}
                px={4}
                justify={"left"}
                transform={tabIndex === 0 ? "scale(1.1)" : "scale(1)"}
                border={tabIndex === 0 ? "1px solid green" : ""}
                _hover={{
                  transform: "scale(1.1)",
                }}
                cursor={"pointer"}
                transition="transform 0.3s"
                onClick={() => showFeature(0)}
              >
                <Icon fontSize="42" as={TbRefresh} bg={"green.500"} color={"white"} p={"2"} borderRadius={"40px"} />
                <Text fontSize={"lg"} as="b" pl={"1"}>
                  Automated Requests
                </Text>
              </HStack>
              <HStack
                py={{ base: 2, lg: 5 }}
                bg={"#f5e4ec"}
                w={{ base: "90%", lg: "100%" }}
                borderRadius={"2xl"}
                px={4}
                justify={"left"}
                transform={tabIndex === 1 ? "scale(1.1)" : "scale(1)"}
                border={tabIndex === 1 ? "1px solid pink" : ""}
                _hover={{
                  transform: "scale(1.1)",
                }}
                cursor={"pointer"}
                transition="transform 0.3s"
                onClick={() => showFeature(1)}
              >
                <Icon fontSize="42" as={FaPaintBrush} bg={"pink.400"} color={"white"} p={"2"} borderRadius={"40px"} />
                <Text fontSize={"lg"} as="b" pl={"1"}>
                  Customize Widget
                </Text>
              </HStack>
              <HStack
                py={{ base: 2, lg: 5 }}
                bg={"#d4ebff"}
                w={{ base: "90%", lg: "100%" }}
                borderRadius={"2xl"}
                px={4}
                justify={"left"}
                transform={tabIndex === 2 ? "scale(1.1)" : "scale(1)"}
                border={tabIndex === 2 ? "1px solid blue" : ""}
                _hover={{
                  transform: "scale(1.1)",
                }}
                cursor={"pointer"}
                transition="transform 0.3s"
                onClick={() => showFeature(2)}
              >
                <Icon fontSize="42" as={BsCameraFill} bg={"blue.400"} color={"white"} p={"2"} borderRadius={"40px"} />
                <Text fontSize={"lg"} as="b" pl={"1"}>
                  Photo Reviews
                </Text>
              </HStack>
              <HStack
                py={{ base: 2, lg: 5 }}
                bg={"#ede5ff"}
                w={{ base: "90%", lg: "100%" }}
                borderRadius={"2xl"}
                px={4}
                justify={"left"}
                transform={tabIndex === 3 ? "scale(1.1)" : "scale(1)"}
                border={tabIndex === 3 ? "1px solid purple" : ""}
                _hover={{
                  transform: "scale(1.1)",
                }}
                cursor={"pointer"}
                transition="transform 0.3s"
                onClick={() => showFeature(3)}
              >
                <Icon fontSize="42" as={MdEmail} bg={"purple.400"} color={"white"} py={"2"} px={"2.2"} borderRadius={"40px"} />
                <Text fontSize={"lg"} as="b" pl={"1"}>
                  Customize Review Email
                </Text>
              </HStack>
              <HStack
                py={{ base: 2, lg: 5 }}
                bg={"#cffefa"}
                w={{ base: "90%", lg: "100%" }}
                borderRadius={"2xl"}
                px={4}
                justify={"left"}
                transform={tabIndex === 4 ? "scale(1.1)" : "scale(1)"}
                border={tabIndex === 4 ? "1px solid teal" : ""}
                _hover={{
                  transform: "scale(1.1)",
                }}
                cursor={"pointer"}
                transition="transform 0.3s"
                onClick={() => showFeature(4)}
              >
                <Icon fontSize="42" as={BsToggles} bg={"teal.300"} color={"white"} py={"2"} borderRadius={"40px"} />
                <Text fontSize={"lg"} as="b" pl={"1"}>
                  Moderate
                </Text>
              </HStack>
              <HStack
                py={{ base: 2, lg: 5 }}
                bg={"#ffebd3"}
                w={{ base: "90%", lg: "100%" }}
                borderRadius={"2xl"}
                px={4}
                justify={"left"}
                transform={tabIndex === 5 ? "scale(1.1)" : "scale(1)"}
                border={tabIndex === 5 ? "1px solid orange" : ""}
                _hover={{
                  transform: "scale(1.1)",
                }}
                cursor={"pointer"}
                transition="transform 0.3s"
                onClick={() => showFeature(5)}
              >
                <Icon fontSize="42" as={SiGoogleanalytics} bg={"orange.300"} color={"white"} py={"2"} borderRadius={"40px"} />
                <Text fontSize={"lg"} as="b" pl={"1"}>
                  Analytics
                </Text>
              </HStack>
            </VStack>
          </WrapItem>
          <WrapItem flex={{ base: "1", md: "1", lg: "1" }} h={{ base: "450px", md: "520px", lg: "760px" }} px={{ base: 2, lg: 0 }}>
            <Box maxW={"5xl"} bg={"white"} py={{ base: 5, md: 10, lg: 10 }} px={{ base: 2, md: 8, lg: 12 }} borderRadius={"30px"} height={"100%"} overflow={"hidden"}>
              <Box className={tabIndex === 0 ? "spawn-features-selected" : "spawn-features"}>
                <Box textAlign={"center"} pb={"10"}>
                  <Text fontWeight={"semibold"} fontSize={"md"}>
                    Automatic review request feature that can be customized to your preferences. You can choose when the requests are sent, based on the number of days after the order is placed or fulfilled.
                  </Text>
                  <Text fontWeight={"semibold"} fontSize={"md"} mt={"3"}>
                    Once you've set up the feature, review requests will be sent automatically, so you can sit back and relax!
                  </Text>
                </Box>
                <Image className="up-to-down-move" src="./screenshots/1.png" boxShadow="lg" borderRadius={"20px"} />
              </Box>
              <Box className={tabIndex === 1 ? "spawn-features-selected" : "spawn-features"}>
                <Box textAlign={"center"} pb={"10"}>
                  <Text fontWeight={"semibold"} fontSize={"md"}>
                    Customize every aspect of your review process with our powerful widget features. Tailor the appearance, sorting, and other elements to align perfectly with your website's unique style and branding.
                  </Text>
                </Box>
                <Image className="up-to-down-move" src="./screenshots/2.png" boxShadow="lg" borderRadius={"20px"} />
              </Box>
              <Box className={tabIndex === 2 ? "spawn-features-selected" : "spawn-features"}>
                <Box textAlign={"center"} pb={"10"}>
                  <Text fontWeight={"semibold"} fontSize={"md"} mt={"3"}>
                    Photo reviews can enhance your customers' shopping experience, boost your brand's reputation, and increase conversion rates.
                  </Text>
                  <Text fontWeight={"semibold"} fontSize={"md"}>
                    With photo reviews, customers can showcase the real-life impact of your products, providing a powerful marketing tool for your business
                  </Text>
                </Box>

                <Image className="up-to-down-move" src="./assets/hero-image2.png" boxShadow="lg" borderRadius={"20px"} />
              </Box>
              <Box className={tabIndex === 3 ? "spawn-features-selected" : "spawn-features"}>
                <Box textAlign={"center"} pb={"10"}>
                  <Text fontWeight={"semibold"} fontSize={"md"}>
                    Our review email feature is fully customizable, allowing you to tailor every aspect of your email to your brand's unique look and feel.
                  </Text>
                  <Text fontWeight={"semibold"} fontSize={"md"} mt={"3"}>
                    With so many options available, you can create review emails that are not only effective but also beautifully crafted to showcase your brand's personality.
                  </Text>
                </Box>

                <Image className="up-to-down-move" src="./screenshots/3.png" boxShadow="lg" borderRadius={"20px"} />
              </Box>
              <Box className={tabIndex === 4 ? "spawn-features-selected" : "spawn-features"}>
                <Box textAlign={"center"} pb={"10"}>
                  <Text fontWeight={"semibold"} fontSize={"md"}>
                    Maintaining a positive online reputation is critical for any business, and our review moderation feature makes it easy for you to control the content that appears on your website.
                  </Text>
                  <Text fontWeight={"semibold"} fontSize={"md"} mt={"3"}>
                    Reply feature allows you to engage with customers, demonstrating your commitment to excellent service and listening to their feedback.
                  </Text>
                </Box>

                <Image className="up-to-down-move" src="./screenshots/4.png" boxShadow="lg" borderRadius={"20px"} />
              </Box>
              <Box className={tabIndex === 5 ? "spawn-features-selected" : "spawn-features"}>
                <Box textAlign={"center"} pb={"10"}>
                  <Text fontWeight={"semibold"} fontSize={"md"} mt={"3"}>
                    Whether you're looking to increase customer engagement or boost sales, our analytics feature provides you with the insights you need to succeed. Don't just rely on guesswork - use our analytics feature to take your business to the next level!
                  </Text>
                </Box>

                <Image className="up-to-down-move" src="./screenshots/5.png" boxShadow="lg" borderRadius={"20px"} />
              </Box>
            </Box>
          </WrapItem>
        </Wrap>
      </Flex>
    </Box>
  );
}
